// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  UpdatePolicy,
} from "./types";


export default __t.row({
  id: __t.u32().primaryKey(),
  autoApplyOrgModules: __t.bool().name("auto_apply_org_modules"),
  get orgUpdateDefault() {
    return UpdatePolicy.name("org_update_default");
  },
  autoApplyProjectModules: __t.bool().name("auto_apply_project_modules"),
});
